/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KubernetesRecordingItem interface.
 */
export function instanceOfKubernetesRecordingItem(value) {
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('requestMethod' in value) || value['requestMethod'] === undefined)
        return false;
    if (!('requestPath' in value) || value['requestPath'] === undefined)
        return false;
    if (!('requestBody' in value) || value['requestBody'] === undefined)
        return false;
    if (!('responseBody' in value) || value['responseBody'] === undefined)
        return false;
    return true;
}
export function KubernetesRecordingItemFromJSON(json) {
    return KubernetesRecordingItemFromJSONTyped(json, false);
}
export function KubernetesRecordingItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timestamp': (new Date(json['timestamp'])),
        'requestMethod': json['request_method'],
        'requestPath': json['request_path'],
        'requestBody': json['request_body'],
        'responseStatus': json['response_status'] == null ? undefined : json['response_status'],
        'responseBody': json['response_body'],
    };
}
export function KubernetesRecordingItemToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'timestamp': ((value['timestamp']).toISOString()),
        'request_method': value['requestMethod'],
        'request_path': value['requestPath'],
        'request_body': value['requestBody'],
        'response_status': value['responseStatus'],
        'response_body': value['responseBody'],
    };
}
